var decorators = {};

export { decorators as __exports };
//# sourceMappingURL=decorators.js.map
